var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { id: "devices-list", tag: "section", fluid: "" } },
    [
      _c(
        "v-overlay",
        { staticClass: "waitoverlay", attrs: { value: _vm.busy } },
        [
          _c("v-progress-circular", {
            staticClass: "mr-4",
            attrs: { indeterminate: "", size: "64" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("global.loading")) + " ")
        ],
        1
      ),
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _vm._v(" " + _vm._s(_vm.$t("devices.title")) + " "),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    disabled: _vm.quotaFull || _vm.isAnonymousEnabled
                  },
                  on: { click: _vm.addDeviceDialog }
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("devices.create-access-code")) + " "
                  )
                ]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "secondary",
                    "aria-label": _vm.$t("devices.refresh-devices")
                  },
                  on: { click: _vm.refreshDevices }
                },
                [_c("v-icon", [_vm._v("mdi-refresh")])],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "div",
                { staticClass: "searchBox" },
                [
                  _c("v-text-field", {
                    attrs: {
                      "append-icon": "mdi-magnify",
                      label: _vm.$t("global.search"),
                      "aria-label":
                        _vm.$t("global.text-field") +
                        " " +
                        _vm.$t("global.search") +
                        " " +
                        _vm.$t("devices.devices"),
                      "single-line": "",
                      "hide-details": ""
                    },
                    model: {
                      value: _vm.search,
                      callback: function($$v) {
                        _vm.search = $$v
                      },
                      expression: "search"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-data-table",
                {
                  attrs: {
                    filterable: "",
                    headers: _vm.headers.map(function(x) {
                      return Object.assign({}, x, { text: _vm.$t(x.text) })
                    }),
                    items: _vm.devices.devices,
                    "item-key": "id",
                    loading: _vm.loading,
                    search: _vm.search,
                    "items-per-page": _vm.rowsPerPage
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item.name",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _vm._v(" " + _vm._s(_vm.clipString(item.name)) + " ")
                        ]
                      }
                    },
                    {
                      key: "item.actions",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-icon",
                                          _vm._g(
                                            {
                                              staticClass: "mr-2",
                                              attrs: {
                                                "aria-label":
                                                  _vm.$t("global.edit") +
                                                  " " +
                                                  _vm.$t(
                                                    "devices.deviceParam",
                                                    [item.name]
                                                  )
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.editItem(item)
                                                }
                                              }
                                            },
                                            on
                                          ),
                                          [_vm._v(" mdi-pencil-outline ")]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [_c("span", [_vm._v(_vm._s(_vm.$t("edit")))])]
                          ),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-icon",
                                          _vm._g(
                                            {
                                              attrs: {
                                                "aria-label":
                                                  _vm.$t("global.delete") +
                                                  " " +
                                                  _vm.$t(
                                                    "devices.deviceParam",
                                                    [item.name]
                                                  )
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.deleteItem(item)
                                                }
                                              }
                                            },
                                            on
                                          ),
                                          [_vm._v(" mdi-delete-outline ")]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [_c("span", [_vm._v(_vm._s(_vm.$t("delete")))])]
                          )
                        ]
                      }
                    },
                    {
                      key: "item.lastSeen",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _vm._v(
                            " " + _vm._s(_vm.displayTime(item.lastSeen)) + " "
                          )
                        ]
                      }
                    },
                    {
                      key: "item.status",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          !item.disabled
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "status mr-2",
                                  class: item.config.operationMode
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "devices.operation-mode-" +
                                            item.config.operationMode
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            : _vm._e(),
                          item.disabled
                            ? _c(
                                "v-chip",
                                { staticClass: "status disabled mr-2" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("globcal.disabled")) +
                                      " "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      }
                    },
                    {
                      key: "item.config.session.user",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.displayName(item.config.session.user)
                              ) +
                              " "
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.selected,
                    callback: function($$v) {
                      _vm.selected = $$v
                    },
                    expression: "selected"
                  }
                },
                [_vm._v(" --> ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "700px" },
              model: {
                value: _vm.showEditDialog,
                callback: function($$v) {
                  _vm.showEditDialog = $$v
                },
                expression: "showEditDialog"
              }
            },
            [
              _c("device-edit", {
                ref: "deviceedit",
                attrs: { device: _vm.editedItem },
                on: { cancel: _vm.closeEditDialog, save: _vm.saveEditDialog }
              })
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "500px" },
              model: {
                value: _vm.showAddDeviceDialog,
                callback: function($$v) {
                  _vm.showAddDeviceDialog = $$v
                },
                expression: "showAddDeviceDialog"
              }
            },
            [
              _c(
                "shortcode-generator",
                { attrs: { action: "registerDevice", description: "hi" } },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("devices.generator-code-description")) +
                      " "
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "500px" },
              model: {
                value: _vm.showDeleteDialog,
                callback: function($$v) {
                  _vm.showDeleteDialog = $$v
                },
                expression: "showDeleteDialog"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _vm._v(_vm._s(_vm.$t("global.confirm")))
                  ]),
                  _c("v-card-text", [
                    _vm._v(_vm._s(_vm.$t("devices.delete-confirm-text")) + " "),
                    _c("span", { staticClass: "font-weight-bold" }, [
                      _vm._v(_vm._s(_vm.selectedDeviceName))
                    ]),
                    _vm._v("?")
                  ]),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "blue" },
                          on: { click: _vm.closeDeleteDialog }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.no")) + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "red" },
                          on: { click: _vm.confirmDeleteItem }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.yes")) + " ")]
                      ),
                      _c("v-spacer")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }